import React from 'react';

import testIds from '@smart-tv/e2e/shared/variables';

import Typography from '@smart-tv/components/typography/typography';

import isFutureDate from '@smart-tv/utils/date/is-future-date';
import formatDuration from '@smart-tv/utils/formatter/format-duration';
import formatTitle from '@smart-tv/utils/formatter/format-title';

import { Props } from './content-item';
import ContentItemTitle from './content-item-title';
import ContentItemImage from './content-item-image';
import ContentItemProgressBar from './content-item-progress-bar';
import ContentItemRecordingAnimation from './content-item-recording-animation';
import ContentItemTimeSpan from './content-item-time-span';

import styles from './content-item.module.scss';

export const ContentItemLiveTVContent: React.FC<Props> = (props: Props) => {
  const {
    contentItem,
    showProgress = true,
    showContentTitle = true,
    focused = false,
    animating,
    setAnimating
  } = props;

  const { title, logo, cover, coverType, startTime, endTime, genre, duration, contentLayout } =
    contentItem;

  return (
    <React.Fragment>
      <div className={styles['live-tv-content']}>
        <ContentItemImage
          cover={logo ? logo : cover}
          coverType={coverType}
          futureContent={startTime ? isFutureDate(startTime) : false}
          focused={focused}
          animating={animating}
          setAnimating={setAnimating}
          liveTV={true}
          contentLayout={contentLayout}
        />
        <div className={styles['text']}>
          {startTime && endTime && (
            <ContentItemTimeSpan
              startTime={startTime}
              endTime={endTime}
              trailingContent={
                <ContentItemRecordingAnimation
                  className={styles['live-tv-content__recording']}
                  contentItem={contentItem}
                />
              }
            />
          )}

          {showContentTitle && <ContentItemTitle>{formatTitle(title)}</ContentItemTitle>}

          {(genre || duration) && (
            <Typography
              noWrap
              variant="caption"
              data-testid={testIds.contentItem.live.duration}
              component="div"
              className={styles['genre-duration']}
            >
              {genre && genre[0]}
              {genre && formatDuration(duration) && ' | '}
              {formatDuration(duration)}
            </Typography>
          )}

          {showProgress && startTime && endTime && !isFutureDate(startTime) && (
            <ContentItemProgressBar liveTV={true} startTime={startTime} endTime={endTime} />
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default ContentItemLiveTVContent;
